import { LINKS, INFO } from "@/lib/constants";

export default function Footer() {
  return (
    <footer className="pt-16 pb-8" style={{ background: "#080808", borderTop: "1px solid rgba(201,168,76,0.25)" }} data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-10 items-start">
        <div>
          <p className="font-display text-xl font-bold gold-text">NABIL BARBERSHOP</p>
          <p className="text-xs mt-2 uppercase" style={{ letterSpacing: "2px", color: "#999999" }}>Bochum-Wattenscheid</p>
        </div>
        <div className="text-sm" style={{ color: "#999999" }}>
          <p>{INFO.address} · 44866 Bochum</p>
          <p className="mt-1">Mo–Fr 09–19 Uhr · Sa 09–18 Uhr</p>
        </div>
        <div className="md:text-right">
          <a href={LINKS.tiktok} target="_blank" rel="noopener noreferrer" className="text-sm hover:underline" style={{ color: "#E8CC7A" }} data-testid="footer-tiktok-link">
            TikTok {INFO.tiktokHandle}
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-12 pt-6 text-center text-xs" style={{ borderTop: "1px solid rgba(255,255,255,0.06)", color: "#666" }}>
        © 2026 Nabil Barbershop
      </div>
    </footer>
  );
}
